import { BaseError } from '@dynamic-labs-sdk/client';

export class PhantomRedirectDecryptionError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'phantom_redirect_decryption_error',
      docsUrl: null,
      name: 'PhantomRedirectDecryptionError',
      shortMessage:
        'Failed to decrypt Phantom redirect response. The encryption keys may be invalid.',
    });
  }
}
